import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28473e59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_page p-d-flex p-flex-column" }
const _hoisted_2 = { class: "p-ml-3 p-mr-3 p-d-flex p-ai-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-chevron-left",
  style: {"fontSize":"1.5rem","color":"black"}
}, null, -1 /* HOISTED */))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "p-ml-2",
  style: {"flex":"1"}
}, " Il tuo profilo ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserInfoEdit = _resolveComponent("UserInfoEdit")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_ShopsEdit = _resolveComponent("ShopsEdit")!
  const _component_LegalEntityEdit = _resolveComponent("LegalEntityEdit")!
  const _component_TabView = _resolveComponent("TabView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:;",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, _hoisted_4),
      _hoisted_5
    ]),
    _createVNode(_component_TabView, {
      scrollable: "",
      lazy: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { header: "Informazioni utente" }, {
          default: _withCtx(() => [
            _createVNode(_component_UserInfoEdit, { isInProfileView: true })
          ]),
          _: 1 /* STABLE */
        }),
        (_ctx.isUserRegistrationComplete)
          ? (_openBlock(), _createBlock(_component_TabPanel, {
              key: 0,
              header: "Negozi"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ShopsEdit, { isInProfileView: true })
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (_ctx.isUserRegistrationComplete)
          ? (_openBlock(), _createBlock(_component_TabPanel, {
              key: 1,
              header: "Dati azienda"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LegalEntityEdit)
              ]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    })
  ]))
}